var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-submit-supplier-order",
        "no-close-on-backdrop": "",
        "hide-header-close": "",
        "hide-footer": "",
        size: "lg",
        centered: "",
      },
      on: { hidden: _vm.onHideModal },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("p", { staticClass: "h4" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editMode
                        ? _vm.$t("Editar Pedido ao Fornecedor")
                        : _vm.$t("Submeter Pedidos ao Fornecedor")
                    ) +
                    " "
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "FormulateForm",
        {
          ref: "supplierOrderForm",
          attrs: { name: "supplierOrderForm" },
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v
            },
            expression: "form",
          },
        },
        [
          _c(
            "b-container",
            [
              _c("FormulateInput", {
                attrs: {
                  type: "group",
                  label: _vm.$t("Pedidos ao Fornecedor"),
                  repeatable: !_vm.editMode,
                  "add-label": _vm.$t("Adicionar Pedido"),
                  "remove-position": "before",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var index = ref.index
                      return [
                        _c(
                          "b-row",
                          { attrs: { "align-h": "center" } },
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "w-100 required",
                                  attrs: {
                                    id: "requested_date_" + index,
                                    name: "requestedDate",
                                    type: "datepicker",
                                    validation: "required",
                                    label: _vm.$t("Data de solicitação"),
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c("FormulateInput", {
                                  staticClass: "w-100",
                                  attrs: {
                                    id: "order_number_" + index,
                                    name: "orderNumber",
                                    type: "text",
                                    label: _vm.$t("Número do pedido"),
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c("e-person-search", {
                                  staticClass: "w-100",
                                  attrs: {
                                    id: "supplier_id_" + index,
                                    name: "supplierId",
                                    "is-supplier": "",
                                    required: "",
                                    label: _vm.$t("Fornecedor"),
                                    "value-is-object": "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onSupplierSelected(
                                        $event,
                                        index
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c(
                                  "b-card-actions",
                                  {
                                    attrs: {
                                      "action-collapse": "",
                                      title: _vm.$t("Anexos"),
                                    },
                                  },
                                  [
                                    _c("files-form", {
                                      attrs: {
                                        files: _vm.getOrderFiles(index),
                                        "is-read-only": false,
                                      },
                                      on: {
                                        "set-files": function (files) {
                                          return _vm.setOrderFiles(index, files)
                                        },
                                        "remove-file": function (file) {
                                          return _vm.removeOrderFile(
                                            index,
                                            file
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "remove",
                    fn: function (ref) {
                      var indexItem = ref.index
                      var removeItem = ref.removeItem
                      return [
                        _vm.form.supplierOrders &&
                        _vm.form.supplierOrders.length > 1 &&
                        !_vm.editMode
                          ? _c(
                              "div",
                              {
                                staticClass: "mb-1 position-absolute",
                                staticStyle: { right: "7px", top: "25%" },
                              },
                              [
                                _c("e-button", {
                                  staticClass: "px-0",
                                  attrs: {
                                    title: _vm.$t("Deletar pedido"),
                                    icon: "trash",
                                    variant: "danger",
                                    size: "sm",
                                  },
                                  on: {
                                    click: function () {
                                      return removeItem(indexItem)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.form.supplierOrders,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "supplierOrders", $$v)
                  },
                  expression: "form.supplierOrders",
                },
              }),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      staticStyle: { gap: "10px" },
                    },
                    [
                      _c("e-button", {
                        attrs: {
                          text: _vm.$t("Voltar"),
                          "text-shortcuts": ["ESC"],
                          variant: "danger",
                        },
                        on: { click: _vm.onHideModal },
                      }),
                      _c("e-button", {
                        attrs: {
                          variant: "primary",
                          type: "submit",
                          busy: _vm.busy,
                          text: _vm.editMode
                            ? _vm.$t("Atualizar")
                            : _vm.$t("Confirmar"),
                        },
                        on: { click: _vm.onConfirm },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }